import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchSimInventoryEntry } from 'simInventory/SimInventoryApi/simInventoryApi';
import { simDetailsQueries } from '../SimInventoryDetails/queries/simDetailsQueries';

export const useSimDetails = (iccid: string) => {
  return useSuspenseQuery({
    queryKey: simDetailsQueries.detail({ iccid }),
    queryFn: () => (iccid ? fetchSimInventoryEntry(iccid) : null),
    refetchOnWindowFocus: false,
  });
};
